import { render } from "./TheMainInfo.vue?vue&type=template&id=ea280d86&scoped=true&ts=true"
import script from "./TheMainInfo.vue?vue&type=script&lang=ts"
export * from "./TheMainInfo.vue?vue&type=script&lang=ts"

import "./TheMainInfo.vue?vue&type=style&index=0&id=ea280d86&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea280d86"]])

export default __exports__